import $ from "jquery"

class Menu {
	constructor() {
		this.listeners();
	}

	listeners() {
		$(".mobile-menu-trigger").on("click", function () {
			if ($(this).hasClass("is-active")) {
				$(".main-navigation").removeClass("is-active");
				$(this).removeClass("is-active");
				$(".main-navigation").removeAttr("style");
				$("body").removeClass('menu-active');
			} else {
				$(".main-navigation").addClass("is-active");
				$(this).addClass("is-active");
				$(".main-navigation").css(
					"height",
					$(".main-navigation").height() - 64
				);
				$("body").removeClass('menu-active').addClass('menu-active');
			}
		});

	}

}

export default Menu;
